var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconcheck(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.40909 9.15L13.8841 0.675C14.0841 0.475 14.3174 0.375 14.5841 0.375C14.8508 0.375 15.0841 0.475 15.2841 0.675C15.4841 0.875 15.5841 1.1125 15.5841 1.3875C15.5841 1.6625 15.4841 1.9 15.2841 2.1L6.10909 11.3C5.90909 11.5 5.67576 11.6 5.40909 11.6C5.14243 11.6 4.90909 11.5 4.70909 11.3L0.409094 7C0.209094 6.8 0.11326 6.5625 0.121594 6.2875C0.129927 6.0125 0.234094 5.775 0.434094 5.575C0.634094 5.375 0.871594 5.275 1.14659 5.275C1.42159 5.275 1.65909 5.375 1.85909 5.575L5.40909 9.15Z",
    fill: "#0A9F2A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconcheck);
export default __webpack_public_path__ + "static/media/iconcheck.cad1e4fd09913c6bd9888773e3faa759.svg";
export { ForwardRef as ReactComponent };